<mat-form-field class="tel-field flex-auto gt-xs:pr-3 w-full relative z-10" floatLabel="always">
    <mat-label class="required">Phone</mat-label>
    <input matInput class="w-full" #telInput [formControl]="field" type="tel">
    <mat-error *ngIf="field.hasError('required') && field.touched">
        Phone number is required
    </mat-error>
    <mat-error *ngIf="field.hasError('incorrect')">
        Please insert valid phone number
    </mat-error>
</mat-form-field>